// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h3[data-v-514ec5c8]{margin:40px 0 0}ul[data-v-514ec5c8]{list-style-type:none;padding:0}li[data-v-514ec5c8]{display:inline-block;margin:0 10px}a[data-v-514ec5c8]{color:#42b983}", ""]);
// Exports
module.exports = exports;
